import axios from "axios"


export const glb_url = process.env.REACT_APP_APIS_BACK || "https://localhost:443"
//export const glb_url = "https://apis.coreskills.fr"

export const basicAuth = process.env.REACT_APP_BASIC_AUTH || "Basic aHVnb0BoZ2xpZ2h0LmZyOkFtcGxpZnlHb29nbGUyMDI2Pw=="
//hugo@hglight.fr
//AmplifyGoogle2026?

export default {

  addOrder: async vals => {
    try {
      const res = await axios.post(glb_url + "/orders/add", vals, {
        headers: { 'Authorization': basicAuth }
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  getAllOrders: async vals => {
    try {
      const res = await axios.get(glb_url + "/orders", {
        headers: { 'Authorization': basicAuth }
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

  updateOrder: async vals => {
    try {
      const res = await axios.post(glb_url + "/orders/edit", vals, {
        headers: { 'Authorization': basicAuth }
      })
      return res.data
    } catch (err) {
      return console.log(err)
    }
  },

}
